import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { environment } from 'src/environments/environment';
import { resGetAllWorkshops } from '../activity/activity.service';
import { resGetAllMeasure } from '../measure/measure.service';
import { resGetAllCourse } from '../e-learning/e-learning.service';
import { ResAllNews } from '../all-news/news.service';
import { ResGetAllArticalByType } from '../articals/articals.service';

interface resGetAllLearning {
  success: boolean;
  message: string;
  result: GetAllLearningResult[];
}

interface GetAllLearningResult {
  CENTER_ID: string;
  CENTER_NAME: string;
  IMAGE_BANNER: string;
  THEME_ID: number;
  CENTER_DESCRIPTION: string;
  IMAGE_PROFILE: string;
  CONTENT2_DETAIL: string;
  RESEARCH_TEXT: string;
  CREATE_DATE?: string;
  UPDATE_DATE?: any;
  CREATE_BY: string;
  VIEW_STATUS: number;
  IMAGE_BANNER_URL: string;
  IMAGE_PROFILE_URL: string;
}

@Injectable({
  providedIn: 'root'
})
export class LearningCenterService {
  token: string;

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {
    this.token = this.authService.getToken();
  }

  getAllLearningCenterAdmin() {
    const headers = new HttpHeaders({ Authorization: this.token ? this.token : environment.KEY });

    return this.http.get<resGetAllLearning>(environment.URL + '/manage_admin/getAllLearningCenterAdmin', { headers: headers });
  }

  getAllWorkshops(centerId) {
    const headers = new HttpHeaders({ Authorization: this.token ? this.token : environment.KEY });

    return this.http.get<resGetAllWorkshops>(environment.URL + `/workshop/getAllWorkShop?CENTER_ID=${centerId}`, { headers: headers });
  }

  getAllMeasure(centerId) {
    const headers = new HttpHeaders({ Authorization: this.token ? this.token : environment.KEY })

    return this.http.get<resGetAllMeasure>(environment.URL + `/measure/getAllMeasure?TYPE=0&FILTER_INFORMANT=0&CENTER_ID=${centerId}`, { headers: headers });
  }

  getAllCourse(centerId) {
    const headers = new HttpHeaders({ Authorization: this.token ? this.token : environment.KEY })

    return this.http.get<resGetAllCourse>(environment.URL + `/course/getAllCourse?TYPE=all&CENTER_ID=${centerId}`, { headers: headers });
  }

  getAllNews(centerId) {
    const headers = new HttpHeaders({ Authorization: this.token ? this.token : environment.KEY });

    return this.http.get<ResAllNews>(environment.URL + `/news/GetAllNews?CENTER_ID=${centerId}`, { headers: headers });
  }

  getAllArticle(centerId) {
    const headers = new HttpHeaders({ Authorization: this.token ? this.token : environment.KEY })

    return this.http.get<ResGetAllArticalByType>(environment.URL + `/artical/getAllArticalByType?ARTICAL_TYPEID=0&CENTER_ID=${centerId}`, { headers: headers });
  }
}
